import Mosaic from 'mosaic-framework';

import '../components/navigation-bar';
import '../components/footer';
import '../components/round-button';

import '../styles/docs.less';


export default new Mosaic({
    name: 'initialization-page',
    created() {
        window.scrollTo({ top: 0 });

        const menubtn = document.getElementById('menu-button');
        menubtn.style.display = 'block';

        if(menubtn.onclick) return;

        menubtn.onclick = () => {
            const menu = document.getElementById('doc-menu');
            menu.style.transform = 'translateX(0%)';
        }
    },
    view() {
        return html`<div class='doc-page'>
            <navigation-bar></navigation-bar>
            
            <h1 class='section-title' tabindex='0'>🏁 Initialization</h1>
            <p class='section-text' tabindex='0'>
                In this section we will go over how to construct a new Mosaic component
                using the constructor options. We will start with an overview of what
                exactly you are creating when you say "new Mosaic()."
            </p>
            <p class='section-text' tabindex='0'>
                A call to "new Mosaic()" (or just "Mosaic()" since it is a function) will
                return what is called a "component instance." Not only will the renderer
                setup the custom web component for you, but it will also return to you a
                copy of that component that matches its current state. This instance is
                simply another DOM node, and you can even print it out to the console to
                see that.
            </p>
            <p class='section-text' tabindex='0'>
                Because it is just another HTML element, we can make direct changes to it
                as we would with any other DOM node. Something like setting the background
                color style, the width, etc., will work just fine. In fact, directly setting
                HTML attributes may make your app faster depending on your use case, but this
                will be discussed in the section about repainting and updating.
            </p>

            <h1 class='section-title' tabindex='0'>Your First Component</h1>
            <p class='section-text' tabindex='0'>
                Now we will get into what goes into the constructor when creating your first 
                component. Mosaic comes with a initialization options that tell the renderer
                what to do with your component. Here is the list of properties that define a
                Mosaic component:
            </p>
            <p class='section-text' tabindex='0' style='padding-left: 40%'>
                <span>name: <span style="color:mediumseagreen">string</span></span>
                <br>
                <span>element: <span style="color:mediumseagreen">string or DOM node</span></span>
                <br>
                <span>data: <span style="color:mediumseagreen">Object</span></span>
                <br>
                <span>created: <span style="color:mediumseagreen">Function</span></span>
                <br>
                <span>willUpdate: <span style="color:mediumseagreen">Function</span></span>
                <br>
                <span>updated: <span style="color:mediumseagreen">Function</span></span>
                <br>
                <span>willDestroy: <span style="color:mediumseagreen">Function</span></span>
                <br>
                <span>received: <span style="color:mediumseagreen">Function</span></span>
                <br>
                <span>mixins: <span style="color:mediumseagreen">Object[]</span></span>
                <br>
                <span>useShadow: <span style="color:mediumseagreen">boolean</span></span>
                <br>
                <span>stylesheets: <span style="color:mediumseagreen">string[] or CSSStyleSheet[]</span></span>
                <br>
                <span>view: <span style="color:mediumseagreen">Function</span></span>
            </p>
            <p class='section-text' tabindex='0'>
                Not all of these options are required - in fact, most are not required.
                The more options you specify, though, the more you can customize your
                components. By specifying one or more of these properties, you can create 
                your first Mosaic component.
            </p>

            <h1 class='section-title' tabindex='0'>HTML Attributes in the Constructor</h1>
            <p class='section-text' tabindex='0'>
                It is important to remember that the Mosaic options also allow you to specify 
                HTMLElement properties. This comes from the fact that Mosaics are just extensions 
                of HTMLElements. Based on the way the library is written, any value that you add
                to the constructor options will be added directly onto the component. And since
                Mosaics are just HTMLElements, this means that you can directly specify HTML 
                attributes such as "contentEditable" or "style" on your component through these
                options. This, however, is <u>not</u> the best practice for component design.
            </p>
            <p class='section-text' tabindex='0'>
                If you are going to set HTML attributes on your component, it is best to do it
                either in the <b>created</b> function or the <b>received</b> function. Otherwise,
                you may run into errors regarding attributes already being present when the component 
                is being created. Using the lifecycle functions, you can set attributes and styles By
                saying "this.contentEditable = true" or "this.style...." etc.
            </p>

            <br>
            <p class='section-text' tabindex='0' style="text-align: center;">
                Click below to go to the next section about the first important property
                in the Mosaic constructor, naming. You can also click to go back to the 
                previous section if you would like a refresher.
            </p>

            <div style="text-align: center;">
                <round-button onclick='${() => this.router.send('/mosaic')}'>
                    <ion-icon name="arrow-round-back"></ion-icon>
                    What is Mosaic?
                </round-button>
                &nbsp;&nbsp;
                <round-button onclick='${() => this.router.send('/naming')}'>
                    Naming your Components
                    <ion-icon name="arrow-round-forward"></ion-icon>
                </round-button>
            </div>

            <app-footer></app-footer>
        </div>`
    }
});